var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18.06,
    height: 15.33,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18.06,
    height: 15.33,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 18.7,
    width: 18.06,
    height: 0.63,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18.06,
    height: 15.33,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.48,
    y: 5.69,
    width: 15.26,
    height: 5.98,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18.06,
    height: 15.33,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.69,
    y: 13.88,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18.06,
    height: 15.33,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.31,
    y: 14.14,
    width: 1.49,
    height: 1.49,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.97,
    y: 14.14,
    width: 0.82,
    height: 0.82,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 13.88,
    width: 2.85,
    height: 0.34,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18.06,
    height: 15.33,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.89,
    y: 14.14,
    width: 1.49,
    height: 1.49,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.55,
    y: 14.14,
    width: 0.82,
    height: 0.82,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.08,
    y: 13.88,
    width: 2.85,
    height: 0.34,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4878"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2129",
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4864"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4766"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-1)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4764",
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4763"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9018",
    d: "M20.75,19.33H3.32c-.18,0-.32-.14-.32-.32s.14-.32,.32-.32H20.75c.18,0,.32,.14,.32,.32s-.14,.32-.32,.32",
    style: {
      fill: "#1a1818"
    }
  })))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2066",
    x: 11.49,
    y: 10.41,
    width: 8.22,
    height: 8.43,
    style: {
      fill: "#d5d6d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9019",
    d: "M11.49,18.84H4.48V10.02l3.5-4.65,3.5,4.65v8.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4771"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4769",
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4768"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-4)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4767"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9020",
    d: "M11.49,11.67h8.22l.03-.84L7.73,5.69l-3.25,4.18v1.43l3.34-4.32,3.67,4.69Z",
    style: {
      fill: "#1a1818"
    }
  })))))))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9021",
    d: "M7.99,5.25L3.36,10.79l.11,.48h1.01v-.74l3.5-4.54v-.73Z",
    style: {
      fill: "#ce3c32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9022",
    d: "M3,10.83l.47,.44L7.63,5.95l4.16,5.32,.47-.44L7.63,4.91,3,10.83Z",
    style: {
      fill: "#e86159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9023",
    d: "M20.6,11.27l.47-.44-3.49-3.5,3.02,3.94Zm-3.02-3.94l-1.14-1.48-1.28-.94,2.42,2.42Z",
    style: {
      fill: "#e86159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9024",
    d: "M7.63,4.91l4.63,5.92h8.81l-4.63-5.92H7.63Z",
    style: {
      fill: "#ef8782"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9025",
    d: "M12.25,10.83l-.47,.44h8.81l.47-.44H12.25Z",
    style: {
      fill: "#ce3c32"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2069",
    x: 6.69,
    y: 13.88,
    width: 2.6,
    height: 4.95,
    style: {
      fill: "#e86159"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2070",
    x: 6.69,
    y: 13.88,
    width: 0.44,
    height: 4.95,
    style: {
      fill: "#ce3c32"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4776"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-5)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4774",
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4773"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-6)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9026",
    d: "M6.69,13.88l2.61,2.61v-2.61h-2.61Z",
    style: {
      fill: "#1a1818"
    }
  })))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2073",
    x: 12.5,
    y: 13.88,
    width: 2.85,
    height: 2.85,
    style: {
      fill: "#3f565f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2074",
    x: 15.02,
    y: 13.88,
    width: 0.33,
    height: 2.85,
    style: {
      fill: "#96999b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2075",
    x: 12.73,
    y: 14.14,
    width: 2.06,
    height: 2.34,
    style: {
      fill: "#74b4d8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4787"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-7)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4779",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4778"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-8)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9027",
    d: "M13.31,14.14l1.49,1.49v-.27l-1.22-1.22h-.27Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4782",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4781"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-9)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9028",
    d: "M14.79,14.96l-.82-.82h.82v.82Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4785",
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4784"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-10)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9029",
    d: "M15.35,13.88l-.33,.34h-2.52v-.34h2.85Z",
    style: {
      fill: "#1a1818"
    }
  })))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2080",
    x: 16.08,
    y: 13.88,
    width: 2.85,
    height: 2.85,
    style: {
      fill: "#3f565f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2081",
    x: 18.6,
    y: 13.88,
    width: 0.33,
    height: 2.85,
    style: {
      fill: "#96999b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2082",
    x: 16.31,
    y: 14.14,
    width: 2.06,
    height: 2.34,
    style: {
      fill: "#74b4d8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4798"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-11)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4790",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4789"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-12)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9030",
    d: "M16.89,14.14l1.49,1.49v-.27l-1.21-1.22h-.27Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4793",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4792"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-13)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9031",
    d: "M18.37,14.96l-.82-.82h.82v.82Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4796",
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4795"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-14)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9032",
    d: "M18.93,13.88l-.33,.34h-2.51v-.34h2.85Z",
    style: {
      fill: "#1a1818"
    }
  })))))))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9033",
    d: "M13.74,4v2.27l1.61,2.06V4h-1.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2087",
    x: 15.35,
    y: 4,
    width: 1.61,
    height: 4.29,
    style: {
      fill: "#d5d6d5"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.36204ce42a36828fa470b63b8e0d3230.svg";
export { ForwardRef as ReactComponent };